import React, { Component } from 'react';
import { Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap';
import logo from '../assets/logo.png';
import text from '../assets/texts.json';
import Login from '../modules/auth/views/login';
import ParticlesBg from 'particles-bg'

class LoginScreen extends Component {

  render() {
    return (
      <div className="bg-gradient text-dark app flex-row align-items-center">
        <ParticlesBg color={["#c94b4b"]} num={200} type="cobweb" bg={{
          position: "absolute",
          top: 0,
          left: 0
        }} />

        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="bg-light p-4">
                  <CardBody>
                    <Login />
                  </CardBody>
                </Card>
                <Card className="py-3">
                  <CardBody className="text-center">
                    <div className="">
                      <img src={logo} alt={text.title} className="mb-3" style={{ maxWidth: 200 }} />
                      <h4>{text.title}</h4>
                      <small>{text.description}</small>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
        {/* </ParticleAnimation> */}
      </div>
    );
  }
}

export default LoginScreen;